import { render, staticRenderFns } from "./header-clean.vue?vue&type=template&id=49fb52d0&scoped=true&"
import script from "./header-clean.vue?vue&type=script&lang=js&"
export * from "./header-clean.vue?vue&type=script&lang=js&"
import style0 from "./header-clean.vue?vue&type=style&index=0&id=49fb52d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb52d0",
  null
  
)

export default component.exports